import { combineReducers } from "redux-immutable";

export default combineReducers({
  auth: require("./auth").default,
  forgot: require("./forgot-password").default,
});
